import React from "react";
import { motion } from "framer-motion";

const WorkProgress = () => {
  const reasons = [
    {
      icon: (
        <svg
          className="w-12 h-12"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M13 7H7v10h10V11h-4V7z" />
          <path d="M13 7V3h8v8h-4" />
        </svg>
      ),
      title: "IT Solutions",
      description:
        "Our IT solutions, driven by talented minds, enable us to deliver innovative, professional, and high-quality products to our clients.",
      step: "01",
    },
    {
      icon: (
        <svg
          className="w-12 h-12"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M7 8h10M7 16h10M5 12h14" />
        </svg>
      ),
      title: "Consultancy for IT",
      description:
        "Our top IT consulting expertise spans over various domains and gives custom-tailored IT consulting services for organizations of any size.",
      step: "02",
    },
    {
      icon: (
        <svg
          className="w-12 h-12"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M3 12l2-2m0 0l7-7 7 7M13 5v6h6" />
          <path d="M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3" />
        </svg>
      ),
      title: "Odoo Services",
      description:
        "Seamless Odoo integration with cloud, CRM, accounting, and third-party applications to unify business operations.",
      step: "03",
    },
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-gray-50 via-white to-gray-100 relative overflow-hidden">
      <div className="container mx-auto px-6">
        {/* Heading */}
        <div className="text-center mb-4 relative z-10">
          {/* <motion.span
            initial={{ opacity: 0, y: -20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="text-indigo-600 font-semibold tracking-wider uppercase"
          >
            Our Services
          </motion.span> */}
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-4xl md:text-5xl font-extrabold text-gray-900 mt-2"
          >
            Transforming Ideas into{" "}
            <span className="text-indigo-600">Reality</span>
          </motion.h2>

        </div>
        <div class="w-20 h-1 bg-black mx-auto mb-16"></div>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 relative z-10">
          {reasons.map((item, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="bg-white/80 backdrop-blur-lg p-8 rounded-2xl shadow-xl hover:shadow-2xl border border-gray-100 relative overflow-hidden group"
            >
              {/* Icon with gradient circle */}
              <div className="w-16 h-16 flex items-center justify-center rounded-full bg-gradient-to-r from-indigo-500 to-blue-500 text-white shadow-lg mb-6">
                {item.icon}
              </div>

              {/* Title */}
              <h3 className="text-2xl font-bold text-gray-800 mb-3 group-hover:text-indigo-600 transition">
                {item.title}
              </h3>

              {/* Description */}
              <p className="text-gray-600 leading-relaxed">{item.description}</p>

              {/* Step number in background */}
              <span className="absolute top-4 right-6 text-7xl font-extrabold text-gray-100/70 select-none">
                {item.step}
              </span>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WorkProgress;
